import { defineStore } from 'pinia';

export const editorChapterStore = defineStore('editor', {
    state: () => ({
        id: null,
        novel_id :null,
        title: null
    }),
    actions: {
        setCurrentChapter(id, novel_id, title) {
            this.id = id;
            this.novel_id = novel_id;
            this.title = title;
        },
        updateChapterTitle(title) {
            this.title = title;
            // 可以在这里添加额外逻辑，如保存到服务器
        }
    },
    getters: {
        currentChapter: (state) => ({
            id: state.id,
            novel_id: state.novel_id,
            title: state.title,
        })
    }
});